<app-page-shell>
  <app-page-hero eyebrow="Transport Planning" title="Truck Plans"
    subtitle="Find plans by release, project, route, driver, vehicle, and execution status.">
    <div actions>
      <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (onClick)="refresh()"></p-button>
      <p-button label="Release Pool" icon="pi pi-list" severity="secondary" [outlined]="true" routerLink="/transport-planning/releases"></p-button>
      <p-button label="Bulk Planning Runs" icon="fa-solid fa-layer-group" severity="secondary" [outlined]="true" routerLink="/transport-planning/bulk-planning"></p-button>
      <p-button label="Run Bulk Plan" icon="fa-solid fa-route" routerLink="/transport-planning/bulk-planning/new"></p-button>
    </div>
  </app-page-hero>

  <app-page-search-panel title="Search Truck Plans" [activeFilters]="activeFilterCount()"
    [resultText]="totalRecords + ' matching plans'" [collapsed]="false"
    (search)="applyFilters()" (clear)="clearFilters()">
    <div class="filter-grid" (keyup.enter)="applyFilters()">
      <div class="filter-field wide"><p-inputGroup><p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planSearch" type="search" [(ngModel)]="filters.search" placeholder="Number, name, plate, place, or shipment" />
        <label for="planSearch">Search plans, releases, projects, fleet, and shipments</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planNumber" [(ngModel)]="filters.planNumber" placeholder="TPL/…" />
        <label for="planNumber">Plan number</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-info-circle"></i></p-inputGroupAddon><p-iftaLabel>
        <p-multiSelect inputId="planStatuses" [options]="statusOptions" [(ngModel)]="filters.statuses" optionLabel="label" optionValue="value"
          placeholder="All statuses" display="chip" [showClear]="true" appendTo="body" styleClass="w-full"></p-multiSelect>
        <label for="planStatuses">Status</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-users"></i></p-inputGroupAddon><p-iftaLabel>
        <p-select inputId="planAssignment" [options]="assignmentOptions" [(ngModel)]="filters.assignment" optionLabel="label" optionValue="value"
          appendTo="body" styleClass="w-full"></p-select>
        <label for="planAssignment">Assignment</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-list"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planRelease" [(ngModel)]="filters.release" placeholder="Release / order number" />
        <label for="planRelease">Release or source number</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planProject" [(ngModel)]="filters.project" placeholder="Project name or number" />
        <label for="planProject">Project</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-box"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planSource" [(ngModel)]="filters.source" placeholder="Source type / reference" />
        <label for="planSource">Source type or number</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planDriver" [(ngModel)]="filters.driver" placeholder="Assigned driver name" />
        <label for="planDriver">Driver</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planVehicle" [(ngModel)]="filters.vehicle" placeholder="Plate or registration" />
        <label for="planVehicle">Vehicle</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planOrigin" [(ngModel)]="filters.origin" placeholder="Pickup location" />
        <label for="planOrigin">Pickup</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-map"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planDestination" [(ngModel)]="filters.destination" placeholder="Dropoff location" />
        <label for="planDestination">Dropoff</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planHorizonFrom" type="date" [(ngModel)]="filters.horizonFrom" />
        <label for="planHorizonFrom">Horizon from</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planHorizonTo" type="date" [(ngModel)]="filters.horizonTo" />
        <label for="planHorizonTo">Horizon to</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar-plus"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planCreatedFrom" type="date" [(ngModel)]="filters.createdFrom" />
        <label for="planCreatedFrom">Created from</label>
      </p-iftaLabel></p-inputGroup></div>
      <div class="filter-field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar-times"></i></p-inputGroupAddon><p-iftaLabel>
        <input pInputText id="planCreatedTo" type="date" [(ngModel)]="filters.createdTo" />
        <label for="planCreatedTo">Created to</label>
      </p-iftaLabel></p-inputGroup></div>
    </div>
  </app-page-search-panel>

  <app-page-metric-strip [metrics]="summaryMetrics()"></app-page-metric-strip>

  @if (message) { <div class="notice" role="alert">{{ message }}</div> }

  <app-page-data-panel title="Plan Directory" subtitle="Assigned resources are shown from plan routes. Open the release list for order-level details."
    [resultText]="totalRecords + ' plans'">
    <p-table [value]="plans" [loading]="isLoading" [lazy]="true" (onLazyLoad)="load($event)"
      [paginator]="true" [rows]="25" [rowsPerPageOptions]="[10, 25, 50, 100]" [first]="first"
      [totalRecords]="totalRecords" [rowHover]="true" [resizableColumns]="true"
      dataKey="planId" sortField="createdAt" [sortOrder]="-1" responsiveLayout="scroll"
      [tableStyle]="{ 'min-width': '116rem' }" styleClass="workspace-table plan-directory-table">
      <ng-template pTemplate="header">
        <tr class="group-head">
          <th colspan="2">Plan</th>
          <th colspan="2">Order demand</th>
          <th colspan="2">Assigned fleet</th>
          <th colspan="2">Movement &amp; execution</th>
          <th rowspan="2" class="actions-col">Actions</th>
        </tr>
        <tr>
          <th pSortableColumn="planNumber">Identity <p-sortIcon field="planNumber"></p-sortIcon></th>
          <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
          <th>Projects &amp; sources</th>
          <th pSortableColumn="releaseCount">Order releases <p-sortIcon field="releaseCount"></p-sortIcon></th>
          <th pSortableColumn="assignedRouteCount">Drivers <p-sortIcon field="assignedRouteCount"></p-sortIcon></th>
          <th>Vehicles</th>
          <th pSortableColumn="horizonStart">Route &amp; schedule <p-sortIcon field="horizonStart"></p-sortIcon></th>
          <th>Shipments</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>
            <button type="button" class="link-button primary" (click)="open(row)">{{ row.planNumber || 'Plan #' + row.planId }}</button>
            @if (row.planName) { <small>{{ row.planName }}</small> }
            <small>Created {{ date(row.createdAt) }}</small>
          </td>
          <td>
            <p-tag [value]="statusLabel(row.status)" [severity]="statusSeverity(row.status)"></p-tag>
            @if (row.stale) { <small class="warning">{{ row.conflictMessage || 'Release conflict needs review' }}</small> }
            @if (row.status === 'CANCELLED') {
              <small>Cancelled {{ date(row.cancelledAt) }}</small>
              @if (row.cancellationReason) { <small>{{ row.cancellationReason }}</small> }
            }
            @if (row.status === 'APPLIED') { <small>Applied {{ date(row.appliedAt) }}</small> }
          </td>
          <td>
            @if (row.projects.length) {
              @for (project of row.projects.slice(0, 2); track project.projectId) {
                <span class="stack-line"><strong>{{ project.projectNumber || project.projectName || 'Project #' + project.projectId }}</strong>
                  @if (project.projectType) { <small>{{ project.projectType }} project</small> }
                  @if (project.projectNumber && project.projectName) { <small>{{ project.projectName }}</small> }
                </span>
              }
              @if (row.projects.length > 2) { <small>+{{ row.projects.length - 2 }} more projects</small> }
            } @else { <span class="muted">No project linked</span> }
            @if (row.sourceTypes.length) { <small>Sources: {{ preview(row.sourceTypes) }}</small> }
          </td>
          <td>
            <button type="button" class="link-button" (click)="toggleReleases(row.planId)"
              [attr.aria-expanded]="expandedPlanIds.has(row.planId)">
              <i class="pi" [class.pi-chevron-down]="expandedPlanIds.has(row.planId)" [class.pi-chevron-right]="!expandedPlanIds.has(row.planId)"></i>
              {{ row.releaseCount }} {{ row.releaseCount === 1 ? 'release' : 'releases' }}
            </button>
            @for (release of row.releases.slice(0, 2); track release.releaseId) {
              <small>{{ release.releaseNumber }}</small>
            }
            @if (row.releaseCount > 2) { <small>+{{ row.releaseCount - 2 }} more</small> }
          </td>
          <td>
            @if (row.assignments.length) {
              @for (assignment of row.assignments.slice(0, 2); track assignment.routeId) {
                <span class="stack-line"><strong>{{ assignment.driverName || (assignment.driverId ? 'Driver #' + assignment.driverId : 'Driver unassigned') }}</strong>
                  <small>Route {{ assignment.routeSequence || '—' }} · {{ assignment.routeStatus || 'Planned' }}</small>
                  @if (assignment.driverOwnershipType) { <small>{{ assignment.driverOwnershipType }} driver</small> }
                </span>
              }
              @if (row.assignments.length > 2) { <small>+{{ row.assignments.length - 2 }} more routes</small> }
            } @else { <span class="muted">No assigned routes</span> }
          </td>
          <td>
            @if (row.assignments.length) {
              @for (assignment of row.assignments.slice(0, 2); track assignment.routeId) {
                <span class="stack-line"><strong>{{ assignment.vehiclePlateNumber || assignment.vehicleRegistrationNumber || assignment.vehicleLabel || (assignment.vehicleId ? 'Vehicle #' + assignment.vehicleId : 'Vehicle unassigned') }}</strong>
                  @if (assignment.vehicleTypeName) { <small>{{ assignment.vehicleTypeName }}</small> }
                  @if (assignment.vehicleOwnershipType) { <small>{{ assignment.vehicleOwnershipType }} vehicle</small> }
                </span>
              }
              @if (row.assignments.length > 2) { <small>+{{ row.assignments.length - 2 }} more routes</small> }
            } @else { <span class="muted">No assigned vehicles</span> }
            @if (!row.assignments.length && row.candidateFleetCount) { <small>{{ row.candidateFleetCount }} fleet candidates</small> }
          </td>
          <td>
            <strong>{{ preview(row.origins, 1) }}</strong><small>to {{ preview(row.destinations, 1) }}</small>
            <small>{{ date(row.horizonStart) }} – {{ date(row.horizonEnd) }}</small>
            <small>{{ row.routeCount }} {{ row.routeCount === 1 ? 'route' : 'routes' }}</small>
          </td>
          <td>
            <strong>{{ row.shipmentCount }} {{ row.shipmentCount === 1 ? 'shipment' : 'shipments' }}</strong>
            @for (number of row.shipmentNumbers.slice(0, 2); track number) { <small>{{ number }}</small> }
            @if (row.shipmentCount > 2) { <small>+{{ row.shipmentCount - 2 }} more</small> }
          </td>
          <td class="actions-col"><p-button label="Open" icon="pi pi-arrow-right" [outlined]="true" (onClick)="open(row)"></p-button></td>
        </tr>
        @if (expandedPlanIds.has(row.planId)) {
          <tr class="release-expansion"><td colspan="9">
            @if (row.assignments.length) {
              <div class="release-heading"><strong>Assigned routes</strong><span>{{ row.routeCount }} total</span></div>
              <div class="assignment-grid">
                @for (assignment of row.assignments; track assignment.routeId) {
                  <div class="assignment-card">
                    <strong>Route {{ assignment.routeSequence || '—' }} · {{ assignment.routeStatus }}</strong>
                    <span><i class="pi pi-user"></i> {{ assignment.driverName || (assignment.driverId ? 'Driver #' + assignment.driverId : 'Driver unassigned') }}</span>
                    <span><i class="pi pi-truck"></i> {{ assignment.vehiclePlateNumber || assignment.vehicleRegistrationNumber || assignment.vehicleLabel || (assignment.vehicleId ? 'Vehicle #' + assignment.vehicleId : 'Vehicle unassigned') }}</span>
                    @if (assignment.vehicleTypeName || assignment.driverOwnershipType || assignment.vehicleOwnershipType) {
                      <small>{{ assignment.vehicleTypeName || 'Vehicle type not set' }} · {{ assignment.driverOwnershipType || 'Driver' }} / {{ assignment.vehicleOwnershipType || 'Vehicle' }}</small>
                    }
                    <small>{{ date(assignment.startTime) }} – {{ date(assignment.endTime) }} · {{ assignment.releaseCount || 0 }} releases</small>
                  </div>
                }
              </div>
            }
            <div class="release-heading"><strong>Order releases in {{ row.planNumber }}</strong><span>{{ row.releaseCount }} total</span></div>
            @if (row.releases.length) {
              <div class="release-grid">
                @for (release of row.releases; track release.releaseId) {
                  <div class="release-card">
                    <div class="release-card-head">
                      <a [routerLink]="['/transport-planning/releases', release.releaseId]">{{ release.releaseNumber }}</a>
                      <span>{{ release.releaseStatus || 'Unknown status' }}</span>
                    </div>
                    <small>{{ release.projectNumber || release.projectName || 'No project' }}{{ release.projectType ? ' (' + release.projectType + ')' : '' }} · {{ release.sourceType || 'Source' }} {{ release.sourceNumber || '' }}</small>
                    <div>{{ release.originName || 'Pickup not set' }} <i class="pi pi-arrow-right"></i> {{ release.destinationName || 'Dropoff not set' }}</div>
                    <small>Pickup {{ date(release.pickupWindowStart) }} · Delivery {{ date(release.deliveryWindowEnd) }}</small>
                  </div>
                }
              </div>
            } @else { <p class="muted">No order releases are linked to this plan.</p> }
          </td></tr>
        }
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="9" class="empty-cell">No truck plans match the current filters.</td></tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>
